import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcTrashcan(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.063 10a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75M14.75 10.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.543 6.8H4.01a.75.75 0 1 1 0-1.5h3.506l.601-1.804A1.75 1.75 0 0 1 9.777 2.3h4.442a1.75 1.75 0 0 1 1.66 1.196l.602 1.804h3.509a.75.75 0 0 1 0 1.5h-.533l-.764 11.663c-.033.502-.06.921-.11 1.264-.053.359-.137.694-.316 1.007a2.75 2.75 0 0 1-1.19 1.115c-.325.158-.664.22-1.026.249-.345.027-.766.027-1.269.027H9.218c-.503 0-.924 0-1.27-.027-.36-.03-.7-.091-1.025-.249a2.75 2.75 0 0 1-1.19-1.115c-.179-.313-.263-.648-.315-1.007-.05-.343-.078-.762-.11-1.264zM9.54 3.97a.25.25 0 0 1 .237-.17h4.442a.25.25 0 0 1 .237.17l.469 1.405H9.072zM6.802 18.336l-.751-11.46h11.898l-.751 11.46c-.036.539-.06.9-.1 1.176-.04.268-.086.396-.135.482a1.25 1.25 0 0 1-.54.507c-.09.043-.22.08-.49.102-.28.023-.64.023-1.18.023H9.247c-.54 0-.9 0-1.18-.023-.27-.021-.4-.06-.49-.102a1.25 1.25 0 0 1-.54-.507c-.05-.086-.096-.214-.135-.482-.04-.277-.064-.637-.1-1.176",
    clipRule: "evenodd"
  }));
}
var IcTrashcan = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTrashcan));

export { IcTrashcan as I };
